/**
 * WebSocket State Constants
 *
 * These constants represent WebSocket connection states and are defined here
 * for compatibility with test environments where the global WebSocket object
 * may not be available.
 *
 * Values match the WebSocket API specification:
 * https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/readyState
 */
export const WS_STATE = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
} as const;

export type WsState = (typeof WS_STATE)[keyof typeof WS_STATE];
